import { oidcConfigServices } from '@/modules/oidc';
import { getSelectedCompanyId } from '@/utils/user';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import { services as oidcServices } from '@nvision/oidc';
import _axios from 'axios';
import i18n from 'i18next';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { API } from '../api';
import { logOut } from '../utils/auth';

let isRefreshing = false;
const refreshSubscribers = [];

function onTokenRefreshed(token) {
  refreshSubscribers.forEach((cb) => cb(token));
}

function subscribeToTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

export function ExpireTokenInterceptor(response) {
  const requestId = response?.response?.headers?.['x-api-requestid'];

  if (response?.response?.status === 401) {
    showNotification({
      message: i18n.t('translation:default.notification.sessionExpired'),
      type: NOTIFICATION_TYPES.ERROR,
      requestId,
    });
    logOut();
    return Promise.reject(response);
  }

  if (response?.code === 'ERR_CANCELED') {
    return Promise.resolve({ status: 499 });
  }

  return Promise.reject(response);
}

export async function setTokenInterceptor(config) {
  const token = localStorage.getItem('token');
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const tokenIdentity = oidcServices.auth.getToken(oidcConfigServices);

  if (userInfo?.tokenExpiry) {
    const { refreshToken, tokenExpiry } = userInfo;
    const currentUTCTime = moment();
    const tokenExpiryTime = moment(tokenExpiry);
    if (currentUTCTime.isAfter(tokenExpiryTime)) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const response = await _axios.post(`${API.SECURITY}/refreshLogin`, {
            refreshToken,
            token,
          });

          const newToken = response.data.token;
          const newUserInfo = { ...response.data, userGuid: uuidv4() };

          localStorage.setItem('token', newToken);
          localStorage.setItem('userInfo', JSON.stringify(newUserInfo));

          isRefreshing = false;
          onTokenRefreshed(newToken);
          config.headers.Authorization = `Bearer ${newToken}`;
          return config;
        } catch (tokenRefreshError) {
          isRefreshing = false;
          logOut();
          return Promise.reject(tokenRefreshError);
        }
      } else {
        return new Promise((resolve) => {
          subscribeToTokenRefresh((newToken) => {
            config.headers.Authorization = `Bearer ${newToken}`;
            resolve(config);
          });
        });
      }
    }
  }
  if (token || tokenIdentity) {
    const isNewFlow = tokenIdentity;
    config.headers.Authorization = `Bearer ${isNewFlow ? tokenIdentity : token}`;
  }
  return config;
}

export async function addCompanyIdInterceptor(config) {
  const selectedCompanyId = getSelectedCompanyId();

  if (selectedCompanyId) {
    config.headers['X-Company-Id'] = selectedCompanyId;
  }

  return config;
}
